import * as types from '../const/action.types';

export function reportLotIsLoading(state = false, action) {
    switch (action.type) {
        case types.REPORT_LOT_IS_LOADING:
            return action.isLoading;
        default:
            return state;
    }
}

export function lottemp(state = {}, action) {
    switch (action.type) {
        case types.REPORT_LOT_FETCH_DATA:
            return action.items;
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/api.reports.lot.reducer.js